import React, { useEffect, useState } from 'react'
import { InputSelect, InputSummernote, InputText } from '../../components/inputs'
import { API_HOST } from '../../consts';
import Axios from 'axios';
import InputCheckBox from './InputCheckBox';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { ModalBody, Modal, ModalHeader, ModalFooter } from 'reactstrap';
import { toast } from 'react-toastify';
import {
  Document,
  SubTitle,
  Paragraph,
  UnorderedList,
  FormContainer,
  DivSelectForm,
  DivFather,
  DivConteiner,
  DivBody,
  DivCheckbox,
  DivHeaderForm,
  SpanTitle,
  HorizontalLine,
  DivGenero,
  DivButtonDelete,
  ButtonPreVisualizar,
  DivButton,
  ButtonCancelar,
  ButtonDelete,
  DivButtonSalvar,
  ButtonPadrao,
} from './styles/CreateRedacaoStyles';

const CreateRedacao = (props) => {
  const [formData, setFormData] = useState({
    id: null,
    periodo: [],
    periodoSelecionado: {},
    tipoOption: [],
    tipoSelecionado: {},
    genero: [],
    generoSelecionado: {},
    criterios: [],
    criteriosSelecionados: [],
    instrucoes: [],
    instrucoesSelecionadas: [],
    textoMotivador: [],
    proposta_de_texto: "",
    nome: "",
    isModalOpen: false,
    showPage: false,
  });

  const isFieldValid = (field) => {
    if (typeof field === 'string') {
      return field.trim().length > 0;
    } else if (typeof field === 'object') {
      return field && Object.keys(field).length > 0;
    }
    return false;
  };

  const validateForm = () => {
    const isValidPeriodo = isFieldValid(formData.periodoSelecionado);
    const isValidTipo = isFieldValid(formData.tipoSelecionado);
    const isValidGenero = isFieldValid(formData.generoSelecionado);
    const isValidNome = isFieldValid(formData.nome);
    const isValidProposta = isFieldValid(formData.proposta_de_texto);
    const isValidTextoMotivador = formData.textoMotivador.length > 0 && formData.textoMotivador.every(texto => isFieldValid(texto.texto));

    return isValidPeriodo && isValidTipo && isValidGenero && isValidNome && isValidProposta && isValidTextoMotivador;
  };

  const fetchData = async () => {
    try {
      const [periodoRes, tipoRes, criteriosRes, instrucoesRes] = await Promise.all([
        Axios.get(`${API_HOST}/core/periodo`),
        Axios.get(`${API_HOST}/redacao_temas/tipos`),
        Axios.get(`${API_HOST}/redacao_temas/criterios`),
        Axios.get(`${API_HOST}/redacao_temas/instrucoes`),
      ]);
      setFormData((prevData) => ({
        ...prevData,
        periodo: periodoRes.data.filter((x) => x.nivel_id !== 1 && x.nivel_id !== 6).map((x) => ({ value: x.id, label: x.descricao })),
        tipoOption: tipoRes.data.map((x) => ({ value: x.id, label: x.nome })),
        criterios: criteriosRes.data.map((x) => ({ value: x.id, label: x.nome })),
        instrucoes: instrucoesRes.data.map((x) => ({ value: x.id, label: x.nome })),
      }));
    } catch (err) {
      console.error(err);
    }
  };

  const fetchGenero = async (tipoId) => {
    if (tipoId) {
      try {
        const params = {
          tipo: tipoId
        };
        const res = await Axios.get(`${API_HOST}/redacao_temas/generos`, { params });
        setFormData((prevState) => ({
          ...prevState,
          genero: res.data.map((x) => ({
            value: x.id,
            label: x.nome
          }))
        }));
      } catch (err) {
        console.error(err);
        setFormData((prevState) => ({
          ...prevState,
        }));
      }
    }
    else {
      setFormData((prevState) => ({
        ...prevState,
        genero: []
      }));
    };
  };

  const fetchTema = async () => {
    if (parseInt(props.match.params.id)) {
      try {
        const res = await Axios.get(`${API_HOST}/redacao_temas/temas/${props.match.params.id}`);
        const convertData = () => {
          return res.data.textos_motivadores.map(texto => ({
            id: texto.id,
            active: true,
            texto: texto.content
          }));
        };
        await fetchGenero(res.data.tipo.id)
        setFormData((prevData) => ({
          ...prevData,
          id: res.data.id,
          nome: res.data.nome,
          criteriosSelecionados: res.data.criterios.map(x => x.id),
          instrucoesSelecionadas: res.data.instrucoes.map(x => x.id),
          textoMotivador: convertData(),
          periodoSelecionado: { value: res.data.periodo.id, label: res.data.periodo.nome },
          generoSelecionado: { value: res.data.genero.id, label: res.data.genero.nome },
          // tipoSelecionado: { value: res.data.tipo.id, label: res.data.tipo.nome },
          tipoSelecionado: res.data.tipo && { value: res.data.tipo.id, label: res.data.tipo.nome },
          proposta_de_texto: res.data.proposta_de_texto,
          showPage: true,
        }));
      } catch (err) {
        console.error(err);
      }
    }
  };

  const postTema = async () => {
    if (validateForm()) {
      try {
        const params = {
          nome: formData.nome,
          periodo: formData.periodoSelecionado.value,
          genero: formData.generoSelecionado.value,
          tipo: formData.tipoSelecionado.value,
          instrucoes: formData.instrucoesSelecionadas,
          criterios: formData.criteriosSelecionados,
          ...criaObjTextosMotivadores(),
          proposta_de_texto: formData.proposta_de_texto,
        };
        if (props.match.params.id) {
          await Axios.put(`${API_HOST}/redacao_temas/temas/${props.match.params.id}`, params);
        } else {
          await Axios.post(`${API_HOST}/redacao_temas/temas`, params);
        }
        window.location.href = `/redacao/temas-redacoes`;
      } catch (err) {
        console.error(err);
      }
    } else {
      toast.error("Preencha todos os campos para gerar o tema")
    }
  };

  const deleteTextoMotivador = async (id) => {
    try {
      await Axios.delete(`${API_HOST}/redacao_temas/texto-motivador/${id}`);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchData();
    if (!parseInt(props.match.params.id)) {
      setFormData((prevState) => ({
        ...prevState,
        periodoSelecionado: {},
        tipoSelecionado: {},
        generoSelecionado: {},
        instrucoesSelecionadas: [],
        criteriosSelecionados: [],
        nome: null,
        proposta_de_texto: null,
        showPage: true,
      }));
    } else {
      fetchTema();
    }
  }, []);

  const criaObjTextosMotivadores = () => {
    const obj = {};
    formData.textoMotivador.forEach((texto) => {
      obj[`texto_motivador_${texto.id}`] = texto.texto;
    });
    return obj;
  };

  const handleAddTextoMotivador = () => {
    setFormData((prevState) => ({
      ...prevState,
      textoMotivador: [...prevState.textoMotivador, { id: prevState.textoMotivador.length, active: true }]
    }));
  };

  const handleDeleteTextoMotivador = (idToRemove) => {
    setFormData((prevState) => {
      const textosFiltrados = prevState.textoMotivador.filter(texto => texto.id !== idToRemove);
      return {
        ...prevState,
        textoMotivador: textosFiltrados,
      };
    });
    if (props.match.params.id) {
      deleteTextoMotivador(idToRemove);
    }
  };

  const handleGerarTema = () => {
    postTema();
  };

  const handleCancel = () => {
    window.location.href = `/redacao/temas-redacoes`;
  };

  const handleGenero = () => {
    if (!formData.tipoSelecionado.value) {
      toast.warn("Selecione o Tipo antes de selecionar o Genero");
    };
  };
  const handleChangeInputs = (e, field) => {
    setFormData((prevState) => ({
      ...prevState,
      [field]: e
    }));
  };

  const handleChangeInputCheckbox = (value, field) => {
    const index = formData[field].findIndex(item => item === value);
    if (index !== -1) {
      setFormData(prevState => ({
        ...prevState,
        [field]: prevState[field].filter(item => item !== value)
      }));
    } else {
      setFormData(prevState => ({
        ...prevState,
        [field]: [...prevState[field], value]
      }));
    }
  };

  const handleChangeTextoMotivador = (e, id) => {
    setFormData((prevState) => ({
      ...prevState,
      textoMotivador: prevState.textoMotivador.map((texto) => texto.id === id ? { ...texto, texto: e } : texto)
    }));
  };

  const createModal = () => {
    return (
      <Modal
        isOpen={formData.isModalOpen}
        size="lg"
        style={{ marginTop: '100px' }}
      >
        <ModalHeader className="header" >
          PRÉ-VISUALIZAÇÃO - CRIAÇÃO DE TEMA DE REDAÇÃO
        </ModalHeader>
        <ModalBody className="p-0">
          <Document>
            <SubTitle>Tema proposto: {formData.nome} </SubTitle>
            <Paragraph>Esta é uma pré-visualização das informações vinculadas à proposta de Tema de Redação.</Paragraph>
            <h2>Instruções:</h2>
            <UnorderedList>
              {formData.instrucoesSelecionadas.map((instrucao) => (
                <>
                  <li key={instrucao}>{formData.instrucoes.find(inst => inst.value === instrucao).label}</li>
                </>
              ))}
            </UnorderedList>
            <h2>Não será analisada a produção textual que:</h2>
            <UnorderedList>
              {formData.criteriosSelecionados.map((criterio) => (
                <>
                  <li key={criterio}>{formData.criterios.find(crit => crit.value === criterio).label}</li>
                </>
              ))}
            </UnorderedList>
            {formData.textoMotivador.map((texto, index) => {
              return (
                <>
                  <h2>Texto motivador {index + 1}: </h2>
                  <div className="html-container" dangerouslySetInnerHTML={{ __html: texto.texto }} />
                </>
              )
            })}
            <HorizontalLine />
            <SubTitle>PROPOSTA DE REDAÇÃO</SubTitle>
            <div className="html-container" dangerouslySetInnerHTML={{ __html: formData.proposta_de_texto }} />
          </Document>
        </ModalBody>
        <ModalFooter
          style={{ display: 'flex', justifyContent: 'center', margin: '10px' }}
        >
          <ButtonPadrao
            onClick={() => setFormData((prevState) => ({ ...prevState, isModalOpen: false }))}
          >
            Fechar pré-vizualização
          </ButtonPadrao>
        </ModalFooter>
      </Modal>)
  }
  let contTextN = 0;

  return (
    formData.showPage &&
    < DivFather >
      <DivConteiner>
        <FormContainer>
          <DivHeaderForm>
            <SpanTitle>Escolha a fase e o gênero para os quais o tema da redação é direcionado</SpanTitle>
            <DivSelectForm>
              <InputSelect
                key={formData.periodo.id}
                label="Série/Ano Escolar"
                col="col-md-4"
                field="periodo"
                selected={formData.periodoSelecionado}
                options={formData.periodo}
                onChange={(e) => handleChangeInputs(e, "periodoSelecionado")}
                required
              />
              <InputSelect
                key={formData.tipoOption.id}
                label="Tipo"
                col="col-md-4"
                field="tipoOption"
                selected={formData.tipoSelecionado || ""}
                options={formData.tipoOption}
                onChange={(e) => { handleChangeInputs(e, "tipoSelecionado"); fetchGenero(e.value) }}
                required
              />
              <InputSelect
                key={formData.genero.id}
                label="Gênero"
                col="col-md-4"
                field="genero"
                selected={formData.generoSelecionado}
                options={formData.genero}
                onChange={(e) => handleChangeInputs(e, "generoSelecionado")}
                onFocus={() => handleGenero()}
                required
              />
            </DivSelectForm>
          </DivHeaderForm>
          <DivBody>
            <DivCheckbox>
              <div style={{ marginTop: '20px', marginLeft: '16px', width: '100%' }}>
                <InputText
                  label="Tema"
                  field="nome"
                  col="col-md-12"
                  value={formData.nome}
                  onChange={(e) => handleChangeInputs(e, "nome")}
                />
              </div>
              <DivGenero>
                <InputCheckBox
                  label="Instruções"
                  field="instrucoes"
                  options={formData.instrucoes}
                  checked={formData.instrucoesSelecionadas}
                  onChange={(e) => handleChangeInputCheckbox(parseInt(e.target.value), "instrucoesSelecionadas")}
                />
              </DivGenero>
              <DivGenero>
                <InputCheckBox
                  label="Critérios de avaliação"
                  field="criterios"
                  options={formData.criterios}
                  checked={formData.criteriosSelecionados}
                  onChange={(e) => handleChangeInputCheckbox(parseInt(e.target.value), "criteriosSelecionados")}
                />
              </DivGenero>
            </DivCheckbox>
            <HorizontalLine />
            {
              formData.textoMotivador.map((textoMotivador) => {
                if (textoMotivador.active) {
                  contTextN++;
                }
                return (
                  <React.Fragment key={textoMotivador.id}>
                    <InputSummernote
                      col="col-sm-12"
                      label={"Texto Motivador " + contTextN}
                      field={"texto_motivador_" + textoMotivador.id}
                      value={textoMotivador.texto}
                      onChange={(e) => handleChangeTextoMotivador(e, textoMotivador.id)}
                    />
                    <DivButtonDelete>
                      <ButtonDelete onClick={() => handleDeleteTextoMotivador(textoMotivador.id)}>
                        Excluir
                      </ButtonDelete>
                    </DivButtonDelete>
                  </React.Fragment>
                );
              })
            }
            <DivButton
              onClick={(e) => handleAddTextoMotivador(e)}
            >
              + Adicionar texto motivador
            </DivButton>
            <HorizontalLine />
            <InputSummernote
              col="col-sm-12"
              label="Proposta de Redação"
              field="proposta_de_texto"
              value={formData.proposta_de_texto}
              onChange={(e) => handleChangeInputs(e, "proposta_de_texto")}
            />
          </DivBody>
          <ButtonPreVisualizar
            onClick={() => setFormData((prevState) => ({ ...prevState, isModalOpen: true }))}
          >
            <VisibilityIcon />  Pré-Visualizar Tema
          </ButtonPreVisualizar>
          <DivButtonSalvar>
            <ButtonCancelar onClick={() => handleCancel()}>Cancelar</ButtonCancelar>
            <ButtonPadrao onClick={() => handleGerarTema()}> {!props.match.params.id ? "Criar tema" : "Salvar"}</ButtonPadrao>
          </DivButtonSalvar>
        </FormContainer>
      </DivConteiner>
      {formData.isModalOpen && createModal()}
    </DivFather >
  )
}

export default CreateRedacao;